import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { DropdownOption } from '@app/models/DropdownOption';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

type ImportInfoProps = {
  editable: boolean;
  importStatus: string | null;
  acceptedFields: any;
  productCategories: DropdownOption[];
  department_options: DropdownOption[];
  country_options: DropdownOption[];
  location_options: DropdownOption[];
  pcOptions: DropdownOption[];
  prOptions: DropdownOption[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  setAcceptedFields: Function;
  form: any;
  importData: any;
  editableUser: any;
};

const ImportInfo: React.FC<ImportInfoProps> = ({
  editable,
  productCategories = [],
  acceptedFields = {}, // Initialize acceptedFields as an empty object by default
  country_options = [],
  location_options = [],
  department_options = [],
  pcOptions = [],
  prOptions = [],
  setAcceptedFields,
  form,
  importData,
  editableUser,
  importStatus,
}) => {
  const [disabledButtons, setDisabledButtons] = useState<Record<string, boolean>>({});
  const [visibleButtons, setButtonVisibility] = useState<Record<string, string>>({});
  const typeValue = Form.useWatch('type', form);
  const canEdit = editable && (!importStatus || importStatus === 'DRAFT' || importStatus === 'New');
  useEffect(() => {
    const importType = localStorage.getItem('selected_import_type');
    if (importType && !form.getFieldValue('type')) {
      form.setFieldsValue({ type: importType });
    }
  }, [form]);

  // console.log('importData:', importData);
  // console.log('product_category:', importData?.product_category);

  // useEffect(() => {
  //   if (importData) {
  //     form.setFieldsValue({
  //       code: importData?.reference_code || '',
  //       type: importData?.type || '',
  //       location_id: importData?.location_id || '',
  //       department_id: importData?.department_id || '',
  //       expire_date: importData?.expire_date || '',
  //       product_reg_type: importData?.product_reg_type || '',
  //       product_category_id: importData?.product_category_id || '',
  //       product_category: importData?.product_category || '',
  //       allowed_weightage: importData?.allowed_weightage || '',
  //       quantity: importData?.quantity || '',
  //       country_ids: importData?.country_ids || [],
  //       consignment_status: importData?.consignment_status || '',
  //       consignment_type: 'Import',
  //       approval_number: importData?.approval_number || '',
  //       pr_registrations_ids: importData?.pr_registration_ids || [],
  //       pre_clearances_ids: importData?.pre_clearances_ids || [],
  //     });

  //     setAcceptedFields(importData.accepted || {});
  //   }
  // }, [form, importData, setAcceptedFields]);
  useEffect(() => {
    console.log(canEdit);
    //console.log(editable, editableUser, importStatus);
    if (!form.getFieldValue('type')) {
      const importType = localStorage.getItem('selected_import_type');
      if (importType) {
        form.setFieldsValue({ type: importType });
      }
    }
  }, [form]);

  const fields: any = [
    {
      name: 'code',
      label: 'Reference Code',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <Input
            style={{ width: '100%' }}
            value={form.getFieldValue('code')}
            onChange={(e) => form.setFieldsValue({ code: e.target.value })}
            placeholder="Enter Code"
          />
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('code')} />
      ),
    },
    {
      name: 'type',
      label: 'Type',
      component: <BaseInput readOnly value={typeValue ?? ''} />,
    },
    {
      name: 'expire_date',
      label: 'Expiration Date',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <DatePicker
            style={{ width: '100%' }}
            value={form.getFieldValue('expire_date') ? moment(form.getFieldValue('expire_date')) : null}
            onChange={(date) => {
              // Format the date to 'YYYY-MM-DD HH:mm:ss' format before saving it
              const formattedDate = date ? date.format('YYYY-MM-DD HH:mm:ss') : null;
              form.setFieldsValue({ expire_date: formattedDate });
            }}
            placeholder="Select Expiration Date"
          />
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('expire_date')} />
      ),
    },
    {
      name: 'product_reg_type',
      label: 'Product Registration Type',
      component: canEdit ? (
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            type={form.getFieldValue('product_reg_type') === 'ENTITY' ? 'primary' : 'default'}
            onClick={() => form.setFieldsValue({ product_reg_type: 'ENTITY' })}
          >
            Entity Registration
          </Button>
          <Button
            type={form.getFieldValue('product_reg_type') === 'EXPORTER' ? 'primary' : 'default'}
            onClick={() => form.setFieldsValue({ product_reg_type: 'EXPORTER' })}
          >
            Exporter Registration
          </Button>
        </div>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('product_reg_type')} />
      ),
    },

    {
      name: 'quantity',
      label: 'Quantity',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <Input
            style={{ width: '100%' }}
            value={form.getFieldValue('quantity')}
            onChange={(e) => form.setFieldsValue({ quantity: e.target.value })}
            placeholder="Enter Quantity"
          />
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('quantity')} />
      ),
    },
    {
      name: 'allowed_weightage',
      label: 'Allowed Weightage',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <Input
            style={{ width: '100%' }}
            value={form.getFieldValue('allowed_weightage')}
            onChange={(e) => form.setFieldsValue({ allowed_weightage: e.target.value })}
            placeholder="Enter Allowed Weightage"
          />
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('allowed_weightage')} />
      ),
    },
    // {
    //   name: 'approval_number',
    //   label: 'Approval Number',
    //   component: canEdit ? (
    //     <Input.Group compact style={{ display: 'flex', width: '100%' }}>
    //       <BaseSelect
    //         allowClear
    //         placeholder="Select Approval Number"
    //         style={{ width: '100%' }}
    //         value={form.getFieldValue('approval_number')}
    //         onChange={(value) => form.setFieldsValue({ approval_number: value })}
    //       />
    //     </Input.Group>
    //   ) : (
    //     <BaseInput readOnly value={form.getFieldValue('approval_number') || 'Not Selected'} />
    //   ),
    // },
    {
      name: 'consignment_status',
      label: 'Consignment Status',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <Select
            style={{ width: '100%' }}
            value={form.getFieldValue('consignment_status')}
            onChange={(value) => form.setFieldsValue({ consignment_status: value })}
            placeholder="Select Consignment Status"
          >
            <Select.Option value="PARTIAL_ARRIVAL">Partial Arrival</Select.Option>
            <Select.Option value="FULL_SHIPMENT">Full Shipment</Select.Option>
          </Select>
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('consignment_status')} />
      ),
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Product Category</Space>}
          name="product_category_id"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                allowClear
                placeholder="Select Product Category"
                disabled={!canEdit}
                options={productCategories}
                style={{ width: '100%' }}
                value={form.getFieldValue('product_category_id')}
                onChange={(value) => form.setFieldsValue({ product_category_id: value })}
              />
            ) : (
              <BaseInput readOnly value={importData?.product_category?.name || 'Not Selected'} />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>
      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Product Registrations</Space>}
          name="pr_registration_ids"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                mode="multiple"
                allowClear
                showSearch
                placeholder="Select Product Registrations"
                disabled={!canEdit || !!acceptedFields['pr_registration_ids']}
                options={prOptions}
                style={{ width: '100%' }}
                value={form.getFieldValue('pr_registration_ids')}
                onChange={(value) => form.setFieldsValue({ pr_registration_ids: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('pr_registration_ids')?.length > 0
                    ? form
                        .getFieldValue('pr_registration_ids')
                        .map((id: any) => prOptions.find((pr) => pr.value === id)?.label)
                        .join(', ') || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Pre - Approval Number</Space>}
          name="pre_clearances_ids"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                mode="multiple"
                allowClear
                showSearch
                placeholder="Select Pre-Clearances"
                disabled={!canEdit || !!acceptedFields['pre_clearances_ids']}
                options={pcOptions}
                style={{ width: '100%' }}
                value={form.getFieldValue('pre_clearances_ids')}
                onChange={(value) => form.setFieldsValue({ pre_clearances_ids: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('pre_clearances_ids')?.length > 0
                    ? form
                        .getFieldValue('pre_clearances_ids')
                        .map((id: any) => pcOptions.find((pc) => pc.value === id)?.label)
                        .join(', ') || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Countries</Space>}
          name="country_ids"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                mode="multiple"
                allowClear
                showSearch
                placeholder="Select Countries"
                disabled={!canEdit || !!acceptedFields['country_ids']}
                options={country_options}
                style={{ width: '100%' }}
                value={form.getFieldValue('country_ids')}
                onChange={(value) => form.setFieldsValue({ country_ids: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('country_ids')?.length > 0
                    ? form
                        .getFieldValue('country_ids')
                        .map((id: any) => country_options.find((country) => country.value === id)?.label)
                        .join(', ') || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item label={<Space style={{ display: 'flex', alignItems: 'center' }}>Location</Space>} name="location_id">
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                allowClear
                showSearch // 🔥 make it searchable
                placeholder="Select Location"
                disabled={!canEdit || !!acceptedFields['location_id']}
                options={location_options}
                style={{ width: '100%' }}
                value={form.getFieldValue('location_id')}
                onChange={(value) => form.setFieldsValue({ location_id: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('location_id')
                    ? location_options.find((location) => location.value === form.getFieldValue('location_id'))
                        ?.label || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Department</Space>}
          name="department_id"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                allowClear
                showSearch
                placeholder="Select Department"
                disabled={!canEdit || !!acceptedFields['department_id']}
                options={department_options}
                style={{ width: '100%' }}
                value={form.getFieldValue('department_id')}
                onChange={(value) => form.setFieldsValue({ department_id: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('department_id')
                    ? department_options.find((department) => department.value === form.getFieldValue('department_id'))
                        ?.label || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Consignment Type</Space>}
          name="consignment_type"
        >
          {/* This is where the fixed "Import" value will be displayed in view mode */}
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            <BaseInput readOnly value="Import" /> {/* Fixed value "Import" */}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      {fields?.map((e: any) => (
        <React.Fragment key={e.name}>
          <Col xs={24} md={12}>
            <Form.Item
              name={e?.name}
              label={<Space style={{ display: 'flex', alignItems: 'center' }}>{e?.label}</Space>}
            >
              {e?.component}
            </Form.Item>
          </Col>
        </React.Fragment>
      ))}
    </Row>
  );
};

export default ImportInfo;
function useMemo(arg0: () => string | undefined, arg1: any[]) {
  throw new Error('Function not implemented.');
}
